import React from "react";


import { Col } from "react-bootstrap";

import { ReactSVG } from "react-svg";


import iconError from "@Icons/SVG/icon-error.svg";
import iconSuccess from "@Icons/SVG/icon-success.svg";


import "./index.scss";


import { InputComponentStatusType } from "@Components/Forms/Inputs/Input/types";


export const InputMessageComponent:React.FC<InputComponentStatusType> = ({
    type, message
}) => {

    return (
        <Col xs={12} className={'input-message-component'}>
            <ReactSVG
                src={type === 'success' ? iconSuccess : iconError}
                wrapper={'span'}
                className={'input-message-component__icon'}
            />
            {message && <span className={'input-message-component__message'}>{message}</span>}
        </Col>
    );

};


export default InputMessageComponent;
